import { render, staticRenderFns } from "./ConsultaMedica.vue?vue&type=template&id=72f2bba6"
import script from "./ConsultaMedica.vue?vue&type=script&lang=js"
export * from "./ConsultaMedica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports